import { render, staticRenderFns } from "./shopSettings.vue?vue&type=template&id=169ccbef&scoped=true"
import script from "./shopSettings.vue?vue&type=script&lang=js"
export * from "./shopSettings.vue?vue&type=script&lang=js"
import style0 from "./shopSettings.vue?vue&type=style&index=0&id=169ccbef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169ccbef",
  null
  
)

export default component.exports